"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelect = void 0;
var _reactSelect = _interopRequireDefault(require("react-select"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const StyledSelect = exports.StyledSelect = (0, _styledComponents.default)(_reactSelect.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: pointer;\n    ", "\n    font-size: ", ";\n    ", "\n    ", "\n    ", "\n\n    .react-select__input-container {\n        color: ", ";\n    }\n\n    .react-select__control,\n    .react-select__control:hover {\n        border: solid 1px; \n        border-color: ", ";\n        ", ";\n    }\n\n    .react-select__control--menu-is-open,\n    .react-select__control--is-focused {\n        ", "\n        border-bottom-left-radius: 0px;\n        border-bottom-right-radius: 0px;\n        box-shadow: 0px 0px 1px 1px ", ";\n    }\n    \n   .react-select__indicator,\n   .react-select__dropdown-indicator {\n       ", "\n        padding: 0px 5px 0px 0px;\n    }\n\n    .react-select__indicator-separator {\n        background: unset;\n    }\n\n    .react-select__control--is-disabled {\n        background-color: ", ";\n    }\n\n    .react-select__menu {\n        ", "\n        color: ", ";\n        margin: 1px 0px;\n        word-wrap: break-word;\n        z-index: 999;\n    }\n\n    .react-select__input {\n        input {\n            margin-bottom: unset;\n        }\n    }\n\n    .react-select__value-container {\n        ", "\n    }\n\n    .react-select__single-value {\n        color: ", ";\n    }\n"])), (0, _Utils.parseProp)('flex'), _ref => {
  let {
    fontSize
  } = _ref;
  return fontSize;
}, _ref2 => {
  let {
    margin
  } = _ref2;
  return !!margin ? "margin: ".concat(margin, ";") : '';
}, (0, _Utils.parseProp)('width', 'min-width'), (0, _Utils.parseProp)('width'), (0, _Utils.getTheme)('textColor'), _ref3 => {
  let {
    hasError,
    theme: {
      dangerColor,
      primaryLighterColor
    }
  } = _ref3;
  return !hasError ? primaryLighterColor : dangerColor;
}, _ref4 => {
  let {
    height
  } = _ref4;
  return !!height ? "height: ".concat(height, ";") : '';
}, _ref5 => {
  let {
    hasError,
    theme: {
      secondayColor
    }
  } = _ref5;
  return hasError ? '' : "border-color: ".concat(secondayColor, " !important;");
}, _ref6 => {
  let {
    hasError,
    theme: {
      dangerColor,
      primaryColor
    }
  } = _ref6;
  return hasError ? dangerColor : primaryColor;
}, _ref7 => {
  let {
    isDisabled
  } = _ref7;
  return !!isDisabled ? 'display: none;' : '';
}, _ref8 => {
  let {
    theme: {
      disabledColor
    }
  } = _ref8;
  return disabledColor;
}, _ref9 => {
  let {
    align
  } = _ref9;
  return align === 'center' ? 'text-align: center;' : '';
}, _ref0 => {
  let {
    theme: {
      textColor
    }
  } = _ref0;
  return textColor;
}, _ref1 => {
  let {
    align
  } = _ref1;
  return align === 'center' ? 'justify-content: center;' : '';
}, _ref10 => {
  let {
    theme: {
      textColor
    }
  } = _ref10;
  return textColor;
});